// profhiloSkinBoostersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const profhiloSkinBoosters: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Profhilo Treatment Dubai",
            "description": "Discover the Profhilo Skin Booster at Elite Body Home - an innovative treatment that transforms your skin from the inside out with intense hydration and firming effects.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["Home", "Services", "Profhilo Treatment Dubai"],
        "hero": {
            "title": "Profhilo Skin Booster",
            "subtitle": "",
            "description": "Discover the Profhilo Skin Booster—now available at Elite Body Home: Profhilo Skin Booster is an innovative new treatment that can transform your skin from the inside out. This cutting-edge formulation intensely moisturizes and firms the skin, focusing on fine lines while reestablishing elasticity for a more even, youthful appearance. Profhilo gives you bloomin long-lasting results that not only enhances your skins natural radiance but it also gives you those refreshed, revitalized looks with just a couple of sessions! Our number one priority is your beauty and confidence, and Elite Body Home provides the most maintained skin experience."
        },
        "howItWorks": {
            "title": "What is Profhilo Treatment?",
            "description": "It's a unique injectable treatment designed to improve skin quality through the stimulation of collagen and elastin production. Unlike traditional dermal fillers, Profhilo has one of the highest concentrations of hyaluronic acid (HA) on the market, so when injected it integrates evenly under the skin and promotes a lifted and plump appearance. It acts by bio-remodeling the facial tissues, enhancing hydration and elasticity, reducing signs of aging without adding volume or changing facial structure."
        },
        "procedureSteps": {
            "heading": "Profhilo Skin Booster Procedure: 5 Steps",
            "para": "Profhilo is quick, minimally invasive and delivers good results for skin rejuvenation and hydration. It's a good idea to familiarize yourself with the process so you know what to expect in your session.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "It all starts with an initial consultation, during which an expert will evaluate your skin issues and aspirations.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "Injection Points",
                    "desc": "Profhilo is injected into Bio Aesthetic Points which ensures both maximum distribution and uptake of the product.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Duration",
                    "desc": "The injection itself only takes about 10 minutes with the entire procedure approximately 30 minutes, including preparation and aftercare instructions.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "Number of Sessions",
                    "desc": "For best results, two sessions are suggested, four weeks apart.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "There are countless advantages of Profhilo treatment affecting both the superficial and deeper skin layers. It's extremely helpful for anyone wanting full skin rejuvenation without invasive surgery or fillers.",
            "items": [
                {
                    "title": "Improved Skin Hydration",
                    "desc": "Profhilo is the latest skin conditioning treatment and works by injecting high concentrations of hyaluronic acid to firm and hydrate the skin.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Enhanced Skin Elasticity",
                    "desc": "It aids in regaining skin flexibility, causing the skin to become firmer, stronger and more elastic.",
                    "icon": "fa-solid fa-arrows-up-down"
                },
                {
                    "title": "Decrease in Fine Lines and Wrinkles",
                    "desc": "Profhilo helps reduce fine lines and wrinkles by inducing collagen generation.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Natural-Looking Results",
                    "desc": "Profhilo delivers very subtle results without changing facial contours, creating an effect that looks very natural.",
                    "icon": "fa-solid fa-face-grin"
                },
                {
                    "title": "Non-Invasive and Painless",
                    "desc": "Using fewer injection points than dermal fillers, Profhilo is low-pain with no downtime.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Improved Skin Texture",
                    "desc": "It helps the skin improve the tone, texture and It makes the skin healthier",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Profhilo is appropriate for adults who want to improve the quality and texture of their skin. Yet assessment of viability is subject to make sure highest benefits and well-being.",
            "items": [
                {
                    "title": "Age Range",
                    "desc": "Usually people above age 30 who are beginning to feel the signs of aging.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "Skin Type",
                    "desc": "Works on overall skin quality without concern of pigmentation problems, so good for all skin types and tones.",
                    "icon": "fa-solid fa-face"
                },
                {
                    "title": "Areas of Treatment",
                    "desc": "While Profhilo is most commonly used on the face, it is safe to use on the neck, hands, and décolletage for full-body rejuvenation.",
                    "icon": "fa-solid fa-location-dot"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "The steps you take to prepare for treatment will heavily dictate the success of your Profhilo results. There are steps you can take in advance of your appointment to help reduce any side effects and increase your results.",
            "items": [
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Avoid taking aspirin or other blood thinners for at least a week leading up to your treatment.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Hydrate",
                    "desc": "In the days before your appointment, drink plenty of water to improve the hydrating effects of Profhilo.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Skincare Routine",
                    "desc": "Stick to a straightforward and mild skin-care routine in the days leading up to the procedure, steering clear of harsh treatments or exfoliants.",
                    "icon": "fa-solid fa-bottle-droplet"
                },
                {
                    "title": "Avoid Alcohol and Smoking",
                    "desc": "Avoid alcohol and smoke for 48 hours prior to your session, as this can influence the healing and recovery process.",
                    "icon": "fa-solid fa-ban-smoking"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Profhilo provides beautiful natural results, giving skin a fresh glow. Knowing that outcome can help set realistic expectations.",
            "items": [
                {
                    "title": "First Effects",
                    "desc": "Within the first week you'll see improved hydration and a soft glow.",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "Long-Term Effects",
                    "desc": "long, the production of collagen and elastin all better, giving way to a more firm, smooth, then young complexion.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Final Outcome",
                    "desc": "You notice the full results of Profhilo after two treatments usually.",
                    "icon": "fa-solid fa-award"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Is the treatment painful?",
                    "answer": "Profhilo involves minimal discomfort. Most patients experience only a slight stinging sensation during the injection."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Common side effects include mild swelling, redness, or bruising at the injection site, which typically subside within 24-48 hours."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "Most patients notice an improvement in skin hydration and texture within a few days, with full results developing over 4 weeks."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bannlubuer-Image-2-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/ebh-before-and-after-67.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/ebh-before-and-after-97.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/ebh-before-and-after-31.jpg"
            ]
        },
        "product": {
            "id": 10,
            "title": "Profhilo Treatment Dubai",
            "price": 199,
            "description": "Discover the Profhilo Skin Booster at Elite Body Home - an innovative treatment that transforms your skin from the inside out with intense hydration and firming effects."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "علاج بروفايلو في دبي",
            "description": "اكتشف علاج بروفايلو لتعزيز البشرة في Elite Body Home - علاج مبتكر يحول بشرتك من الداخل إلى الخارج بترطيب عميق وتأثيرات شدّ للبشرة.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "علاج بروفايلو في دبي"],
        "hero": {
            "title": "إبرة النضارة بروفايلو",
            "subtitle": "",
            "description": "تعرفي على علاج بروفايلو لتعزيز نضارة البشرة - متوفرة الآن في ايليت بودي هوم: تعد إبرة بروفايلو للنضارة علاج ثوري يعمل على تجديد البشرة من الداخل، حيث يجمع بين الترطيب العميق وشد البشرة بجانب استهدافه للخطوط الدقيقة واستعادة مرونة البشرة، لمنحك مظهرًا أكثر نعومة وشبابًا. ستحصلين على نتائج تدوم طويلاً، حيث لا يكتفي بتعزيز إشراقة بشرتك الطبيعية فقط، بل يمنحك أيضًا مظهرًا منتعشًا ومتجددًا، وكل ذلك من خلال عدة جلسات فقط. في ايليت بودي هوم، نضع جمالك وثقتك بنفسك في المقام الأول، ونقدم لك تجربة العناية بالبشرة الأكثر توازنًا."
        },
        "howItWorks": {
            "title": "ما هو علاج بروفايلو؟",
            "description": "يُحقن علاج بروفايلو المميز لتحسين جودة البشرة من خلال تحفيز إنتاج الكولاجين والإيلاستين. يتميز بروفايلو باحتوائه على أحد أعلى تركيزات حمض الهيالورونيك المتوفرة في السوق على عكس الفيلر الجلدي التقليدي، مما يجعله يتوزع بشكل متجانس تحت الجلد فور حقنه ويُعزز المظهر المشدود والممتلئ للبشرة. يعمل بروفايلو على إعادة ترميم أنسجة الوجه حيويًا، فيعزز الترطيب ومرونة الجلد، ويقلل من مظهر علامات التقدم في العمر، دون أن يضيف حجمًا أو يُغير من ملامح الوجه الطبيعية."
        },
        "procedureSteps": {
            "heading": "إجراء علاج بروفايلو لتعزيز نضارة البشرة: 5 خطوات أساسية",
            "para": "يُعد علاج بروفايلو إجراءً سريعًا، وغير جراحي، ويوفر نتائج فعالة لترطيب وتجديد البشرة. يساعد التعرف على خطوات الجلسة الاستعداد التام لما سيحدث:",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يبدأ الإجراء بجلسة استشارية أولية، يقوم خلالها الطبيب بتقييم مشكلات بشرتك والطموحات.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "نقاط الحقن",
                    "desc": "تُحقن إبر بروفايلو في نقاط جمالية مدروسة تُعرف باسم Bio Aesthetic Points، لضمان توزيع متساوي وامتصاص فعال للمنتج في البشرة.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "مدة الجلسة",
                    "desc": "تستغرق عملية الحقن نفسها حوالي 10 دقائق، بينما تمتد الجلسة الكاملة إلى نحو 30 دقيقة، لتضمنها على تحضيرات قبل العلاج وتعليمات بعد العلاج.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "عدد الجلسات",
                    "desc": "يُنصح بإجراء جلستين بفاصل 4 أسابيع بينهما، للحصول على أفضل النتائج.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "",
            "para": "يتميز علاج بروفايلو بالعديد من الفوائد التي تؤثر في الطبقات السطحية والعميقة من البشرة، ويُعد خيارًا مثاليًا لمن يرغب في تجديد شامل للبشرة دون اللجوء إلى الجراحة أو الفيلر.",
            "items": [
                {
                    "title": "ترطيب عميق للبشرة",
                    "desc": "يُعتبر علاج بروفايلو من أحدث طرق تجديد البشرة، ويعمل من خلال حقن تركيز عالي من حمض الهيالورونيك لترطيب وشد الجلد بفعالية.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "زيادة مرونة البشرة",
                    "desc": "يساعد في استعادة مرونة الجلد، مما يجعل البشرة أكثر تماسُكًا وقوة ومرونة.",
                    "icon": "fa-solid fa-arrows-up-down"
                },
                {
                    "title": "تقليل الخطوط الرفيعة والتجاعيد",
                    "desc": "يُحفز إنتاج الكولاجين في الجلد، مما يؤدي إلى تقليل التجاعيد والخطوط الدقيقة بشكل ملحوظ.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "يُقدم علاج بروفايلو نتائج دقيقة دون تغيير ملامح الوجه، مما يمنح البشرة مظهرًا طبيعيًا.",
                    "icon": "fa-solid fa-face-grin"
                },
                {
                    "title": "إجراء غير جراحي وغير مؤلم",
                    "desc": "يعتمد على نقاط حقن أقل من الفيلر، حيث يعد إجراء منخفض الألم ولا يتطلب التوقف عن الأنشطة اليومية.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "تحسين ملمس البشرة",
                    "desc": "يساهم في توحيد لون البشرة وتحسين ملمسها، مما يمنحها مظهرًا صحيًا.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "يُناسب علاج بروفايلو للبالغين الذين يرغبون في تحسين جودة بشرتهم وملمسها، ولكن يجب تقييم صلاحية العلاج لكل حالة لضمان أقصى فائدة وسلامة.",
            "items": [
                {
                    "title": "الفئة العمرية",
                    "desc": "يُوصى به عادةً للأشخاص الذين تجاوزوا سن الثلاثين وبدأوا يلاحظون ظهور علامات الشيخوخة.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "نوع البشرة",
                    "desc": "يتوافق علاج بروفايلو مع جميع أنواع وألوان البشرة، لأنه لا يعتمد على لون الجلد، بل يعمل على تحسين الجودة العامة للبشرة.",
                    "icon": "fa-solid fa-face"
                },
                {
                    "title": "مناطق العلاج",
                    "desc": "رغم أن الوجه هو أكثر المناطق شيوعًا لاستخدام بروفايلو، إلا أنه يُستخدم بأمان أيضًا على الرقبة واليدين ومنطقة أعلى الصدر (الديكولتيه) للحصول على تجديد شامل.",
                    "icon": "fa-solid fa-location-dot"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "تُعد الخطوات التحضيرية قبل العلاج عاملاً مهمًا في تحقيق أفضل النتائج الممكنة، حيث يمكنك اتخاذ بعض الإجراءات البسيطة قبل الموعد لتقليل أي آثار جانبية وتعزيز فاعلية النتائج.",
            "items": [
                {
                    "title": "تجنب مُميعات الدم",
                    "desc": "يُفضل الامتناع عن تناول الأسبرين أو أي أدوية مُميعة للدم لمدة لا تقل عن أسبوع قبل الجلسة.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الحفاظ على ترطيب",
                    "desc": "احرص على شرب كميات كافية من الماء في الأيام السابقة للموعد، فذلك يعزز من تأثير علاج بروفايلو المرطب للبشرة.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "روتين العناية بالبشرة",
                    "desc": "اتبع روتينًا بسيطًا ولطيفًا للعناية بالبشرة، وتجنب استخدام المقشرات أو المنتجات القاسية على البشرة قبل الجلسة بعدة أيام.",
                    "icon": "fa-solid fa-bottle-droplet"
                },
                {
                    "title": "الامتناع عن الكحول والتدخين",
                    "desc": "امتنع عن تناول الكحول أو التدخين لمدة 48 ساعة قبل الجلسة، لأنهما قد يؤثران سلبًا على عملية التعافي بعد العلاج.",
                    "icon": "fa-solid fa-ban-smoking"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يحقق بروفايلو نتائج طبيعية وجذابة، مما يمنح البشرة إشراقة صحية. يساعد معرفة النتائج المتوقعة على وضع توقعات واقعية للنتائج.",
            "items": [
                {
                    "title": "النتائج الأولية",
                    "desc": "ستلاحظ تحسن في ترطيب البشرة وتحقيق إشراقة ناعمة خلال الأسبوع الأول.",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "النتائج على المدى الطويل",
                    "desc": "يعزز علاج بروفايلو إنتاج الكولاجين والإيلاستين، مما يؤدي إلى بشرة أكثر تماسكًا ونعومة وشبابًا.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "النتيجة النهائية",
                    "desc": "تظهر النتائج الكاملة بعد جلستين من العلاج عادةً.",
                    "icon": "fa-solid fa-award"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "يتضمن علاج بروفايلو حد أدنى من الانزعاج. معظم المرضى يشعرون فقط بوخز خفيف أثناء الحقن."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "تشمل الآثار الجانبية الشائعة تورم خفيف، احمرار، أو كدمات في موقع الحقن، والتي تختفي عادةً خلال 24-48 ساعة."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "يلاحظ معظم المرضى تحسنًا في ترطيب البشرة وملمسها خلال بضعة أيام، مع تطور النتائج الكاملة خلال 4 أسابيع."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []

    }
};
